import { useLayoutEffect } from "react";
import ContainerSignInEmail from "./Components/ContainerSignInEmail";
import LiquidGlass from "../../Components/Style/LiquidGlass";
import HeroBG from "../../Components/Style/HeroBG";

export default function SignInEmail() {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative flex flex-col justify-center items-center min-h-dvh w-screen bg-zi-bg1-light dark:bg-zi-bg1-dark p-4">
      <div className="absolute inset-0 z-0 transition-none">
        <HeroBG />
      </div>
      <LiquidGlass tag="div" rounded="3xl" className="rounded-3xl max-w-sm w-full flex z-10" childrenClassName="w-full">
        <ContainerSignInEmail text="ورود به حساب کاربری" />
      </LiquidGlass>
    </div>
  );
}
